import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

import { FilterService } from '../../../core/+state/filter.service';

@Component({
  selector: 'locumsnest-common',
  template: '',
  styles: [''],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CommonComponent implements OnInit {
  constructor(private filterService: FilterService) {}

  ngOnInit() {
    this.filterService.initializeFilters();
  }
}
